import React, {useState} from 'react';
import './App.scss';
import classNames from "classnames";

import {OrderForm} from "./component/OrderForm";
import {StepCalculator} from "./component/StepCalculator";

function App({settings, form, getTotal}) {
  let stepItems = Object.keys(settings).map((key, index) => ({
    name: key,
    column: settings[key].column,
    marker: `${index + 1}`,
    content: settings[key].title,
    values: settings[key].values
  }));
  stepItems.push({
    name: 'price',
    marker: `${stepItems.length + 1}`,
    content: 'Узнайте цену'
  });
  stepItems = stepItems.map((item, index) => {
    return Object.assign({}, item, {
      prev: (index > 0) ? stepItems[index - 1].name : null,
      next: (index < stepItems.length - 1) ? stepItems[index + 1].name : null
    });
  });

  let [activeStep, setActiveStep] = useState(stepItems[0]);

  return (
    <div className="App">
      <StepCalculator
        steps={stepItems}
        getTotal={getTotal}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
      >
        {({total, values, orderItems}) => {
          return <div className={classNames("clc-step-total", {
            "is-hidden": activeStep.name !== 'price'
          })}>
            <div className="columns">
              <div className="column is-half">
                <h2 className="title is-4">Вы выбрали:</h2>
                {values}

                <h2 className="subtitle is-4">Итоговая цена: {total} руб.</h2>
              </div>
              <div className="column is-half">
                <OrderForm form={form} total={total} order={orderItems} />
              </div>
            </div>
          </div>;
        }}
      </StepCalculator>
    </div>
  );
}

export default App;
